<template>
    <layout name="LayoutDefault">
        <div class="About">
            <div class="breadcrumbs">
                <div class="container">
                    <div class="row">
                        <div class="col-auto">
                            <h3>অনুসন্ধান {{ this.$route.query.keyword }} এর ফলাফল</h3>
                        </div>
                        <div class="col-auto ml-auto">
                            <ul class="list-inline">
                                <li class="list-inline-item"><a class="text-white" href="/">হোম</a></li>
                                <li class="list-inline-item">/</li>
                                <li class="list-inline-item text-white text-uppercase">বই এর নাম দ্বারা অনুসন্ধান করুন</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row">
                        <div class="col-lg-12 ">

                            <div class="section-items">
                                <div class="row">

                                    <div v-for="(item, k) in products" class="col-lg-2 col-sm-6 col-6 section-item books" v-bind:key="k">
                                        <a :href="`${baseUrl}book/${item.id}`">
                                            <span v-if="item.badge" class="badgeText">{{ item.badge }}</span>
                                            <div v-if="item.discount > 0" class="discount-badge">
                                                <span>{{ item.discount }}</span>
                                                <span v-if="item.discount_type == 'Percent'">%</span>
                                                <span v-else class="taka-off">Tk.</span>
                                                <div>OFF</div>
                                            </div>
                                            <ProductImage :image="item.image" />
                                            <ProductNameH4 :product_name="item.product_name" />
                                            <!-- <h4 v-if="item.product_name.length < 14">{{ item.product_name }}</h4>
                                            <h4 v-if="item.product_name.length >= 14" :title="`${item.product_name}`">{{ item.product_name.substr(0, 14) + '...' }}</h4> -->
                                        </a>
                                        <span v-for="(author, index) in item.authors" v-bind:key="index">
                                            <a :href="`${baseUrl}author/${author.author_id}`">{{ author.author_name }}</a> <span v-if="index + 1 < item.authors.length">, </span>
                                        </span>
                                        <div class="item-price">
                                            <div v-if="item.discount > 0" class="item-price">Price: Tk. {{ item.price }}
                                            </div>
                                            <div class="item-regular-price">Regular Price: Tk. {{ item.orginal_price }} </div>
                                        </div>
                                    </div>

                                    <div v-if="loading">Loading...</div>
                                    <div v-if="products.length < 1 && !loading">কোন বই খুজে পাওয়া যাইনি</div>

                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <!-- /.container -->

        </div>
    </layout>
</template>

<script>
import Layout from '../layouts/Layout';
import VueLoadImage from 'vue-load-image';
import ProductImage from './common/ProductImage.vue';
import ProductNameH4 from "./common/ProductNameH4.vue";

export default {
    data() {
        return {
            products: [],
            loading: true,
        }
    },
    components: {
        Layout,
        VueLoadImage,
        ProductImage,
        ProductNameH4
    },
    methods: {
        getProducts() {
            fetch(this.APIURL + 'products-resources/search/' + this.$route.query.keyword)
                .then(response => response.json())
                .then(json => { this.products = json.data; this.loading = false })
        }
    },
    mounted() {
        this.getProducts();
    }
};
</script>
